/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Recherche globale de l\'espace pro (barre du header)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GlobalSearchRecentActivityDto } from './GlobalSearchRecentActivityDto';
import {
    GlobalSearchRecentActivityDtoFromJSON,
    GlobalSearchRecentActivityDtoFromJSONTyped,
    GlobalSearchRecentActivityDtoToJSON,
    GlobalSearchRecentActivityDtoToJSONTyped,
} from './GlobalSearchRecentActivityDto';

/**
 * Contexte enrichi d'un client (3 premiers items du groupe client uniquement)
 * @export
 * @interface GlobalSearchClientContextDto
 */
export interface GlobalSearchClientContextDto {
    /**
     * Nombre de contrats du client
     * @type {number}
     * @memberof GlobalSearchClientContextDto
     */
    activeContractsCount?: number;
    /**
     * Nombre de devis du client (tous ses dossiers du périmètre)
     * @type {number}
     * @memberof GlobalSearchClientContextDto
     */
    quotesCount?: number;
    /**
     * Nombre de simulations du client
     * @type {number}
     * @memberof GlobalSearchClientContextDto
     */
    simulationsCount?: number;
    /**
     * Ses 2 dernières simulations, plus récentes d'abord (id = risqueAssureId)
     * @type {Array<GlobalSearchRecentActivityDto>}
     * @memberof GlobalSearchClientContextDto
     */
    recentActivities?: Array<GlobalSearchRecentActivityDto>;
}

/**
 * Check if a given object implements the GlobalSearchClientContextDto interface.
 */
export function instanceOfGlobalSearchClientContextDto(value: object): value is GlobalSearchClientContextDto {
    return true;
}

export function GlobalSearchClientContextDtoFromJSON(json: any): GlobalSearchClientContextDto {
    return GlobalSearchClientContextDtoFromJSONTyped(json, false);
}

export function GlobalSearchClientContextDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalSearchClientContextDto {
    if (json == null) {
        return json;
    }
    return {
        
        'activeContractsCount': json['activeContractsCount'] == null ? undefined : json['activeContractsCount'],
        'quotesCount': json['quotesCount'] == null ? undefined : json['quotesCount'],
        'simulationsCount': json['simulationsCount'] == null ? undefined : json['simulationsCount'],
        'recentActivities': json['recentActivities'] == null ? undefined : ((json['recentActivities'] as Array<any>).map(GlobalSearchRecentActivityDtoFromJSON)),
    };
}

export function GlobalSearchClientContextDtoToJSON(json: any): GlobalSearchClientContextDto {
    return GlobalSearchClientContextDtoToJSONTyped(json, false);
}

export function GlobalSearchClientContextDtoToJSONTyped(value?: GlobalSearchClientContextDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'activeContractsCount': value['activeContractsCount'],
        'quotesCount': value['quotesCount'],
        'simulationsCount': value['simulationsCount'],
        'recentActivities': value['recentActivities'] == null ? undefined : ((value['recentActivities'] as Array<any>).map(GlobalSearchRecentActivityDtoToJSON)),
    };
}

